const commaSeparate = (arr) => arr.filter(Boolean).join(", ");

export default commaSeparate;
